<template>
  <Card class="pa-4">
    <FlexColumn>
      <Label size="h6" bold text="職歴" />
      <FlexColumn v-for="(career, index) in applicant.careers" :key="`applicant-careers-card-${index}`">
        <FlexRow>
          <Label bold :text="career.companyName" />
          <FlexRow>
            <FlexRow :space="0">
              <Label bold text="(" />
              <Label bold :text="startAt(career)" />
            </FlexRow>
            <Label bold text="-" />
            <FlexRow :space="0">
              <Label bold :text="endAt(career)" />
              <Label bold text=")" />
            </FlexRow>
          </FlexRow>
        </FlexRow>
        <FlexRow>
          <Label :text="career.position" />
          <Label bold text="-" />
          <Label :text="employmentStatus(career)" />
        </FlexRow>
        <TextView :text="career.jobDetail" />
        <Divider v-if="applicant.careers.length - 1 !== index" />
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import TextView from "@/components/atoms/TextView";
import Divider from "@/components/atoms/Divider";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantCareersCard",
  components: {Divider, TextView, FlexRow, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    startAt() {
      return (career) => {
        return this.dateToYearMonthText(career.startAt)
      }
    },
    endAt() {
      return (career) => {
        if (career.endAt) {
          return this.dateToYearMonthText(career.endAt)
        }
        return "現在"
      }
    },
    employmentStatus() {
      return (career) => {
        return this.constsToText(career.employmentStatus, this.consts.employmentStatus)
      }
    }
  }
}
</script>

<style scoped>

</style>
